import {Component} from "react";
import {Link} from "react-router-dom";

export default class NoMatchRoute extends Component{
    render() {
        return (
            <div className="text-white header-light flex flex-wrap justify-center text-center items-center">
                <div>
                    <h2 className="text-3xl">Nie znaleziono strony!</h2>
                    <div>
                        <Link to="/" className='text-blue-500'>Go to the home page</Link>
                    </div>
                </div>
            </div>
        );
    }
}